import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = false

const savedModalOpenSlice = createSlice({
  name: 'savedModalOpen',
  initialState,
  reducers: {
    toggleSavedModal(state, _action: PayloadAction<{ open: boolean }>) {
      return !state
    },
  },
})

export const { toggleSavedModal } = savedModalOpenSlice.actions
export default savedModalOpenSlice.reducer
